import { PayloadAction } from "@reduxjs/toolkit";
import { LoanState } from "../loan.slice.ts";
import { GetDocumentsDocTypeEnum } from "../../../../orchestrator-api-client";
import { GetDocumentsListPayload } from "../../../actions/get-documents-list.action.ts";

export const getDocumentsListReducer = (
  state: LoanState,
  action: PayloadAction<GetDocumentsListPayload>,
) => {
  if (action.payload.documentType === GetDocumentsDocTypeEnum.Payrolls) {
    state.payrolls = action.payload;
  } else if (
    action.payload.documentType === GetDocumentsDocTypeEnum.AccountStatement
  ) {
    state.accountStatement = action.payload;
  }
};
